import { isDevEnv } from '../../config/app';

export const getDefaultLocationId = () =>
  isDevEnv()
    ? '897b5b00-57cf-423e-b13e-646ab73880fb'
    : 'dfbbf8cd-ac87-42be-87fc-2c243272f122';
